Modal.prototype._hide = Modal.prototype.hide

Modal.prototype.hide = function () {
  if (document.activeElement) {
    document.activeElement.blur()
  }
  this._hide()
}

Modal.prototype._createBackdrop = function () {
  if (!this._isHidden) return

  const backdropWrapper = document.createElement('div')
  backdropWrapper.setAttribute('class', 'thq-tw-application')

  const backdropEl = document.createElement('div')
  backdropEl.setAttribute('data-modal-backdrop', '')
  backdropEl.setAttribute('id', this._instanceId + '-backdrop')
  backdropEl.classList.add(...this._options.backdropClasses.split(' '))

  const zIndex = parseInt(window.getComputedStyle(this._targetEl).zIndex, 10)
  if (!Number.isNaN(zIndex)) {
    backdropEl.style.zIndex = zIndex - 1
  }

  document.querySelector('body').append(backdropWrapper)
  backdropWrapper.appendChild(backdropEl)
  this._backdropEl = backdropEl
}

Modal.prototype._destroyBackdropEl = function () {
  const backdropEl = document.querySelector('#' + this._instanceId + '-backdrop')
  if (backdropEl && this._targetEl.getAttribute('aria-hidden') === 'true') {
    backdropEl.parentElement.remove()
  }
}
